import { render } from "./AdminUserCreationScreen.vue?vue&type=template&id=6bc92602&scoped=true"
import script from "./AdminUserCreationScreen.vue?vue&type=script&lang=js"
export * from "./AdminUserCreationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=6bc92602&lang=scss&scoped=true"
import "./AdminUserCreationScreen.vue?vue&type=style&index=1&id=6bc92602&lang=scss&scoped=true"

import exportComponent from "/var/www/html/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc92602"]])

export default __exports__